export const DEFAULT_FOOTER_CONFIG = {
    copyrightText: '© 2026 竞赛管理系统',
    icpFiling: { number: '', url: 'https://beian.miit.gov.cn', enabled: false },
    linkGroups: [],
};
//# sourceMappingURL=footer.js.map